import { makeObservable, observable, action } from 'mobx';
import { UIElementExtended } from './store-stripes-base';
import { RootStore } from './store-root';

class UIStoreProvider {
  isStripesVisible = true;
  heroElement: UIElementExtended | null = null;
  private readonly rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      isStripesVisible: observable,
      heroElement: observable,
      setStripesVisibility: action,
      setHeroElement: action,
      clearStripes: action,
      handleSelectUniverse: action
    });
  }

  setStripesVisibility = (visible: boolean) => {
    this.isStripesVisible = visible;
  };

  setHeroElement = (hero: UIElementExtended | null) => {
    this.heroElement = hero;
  };

  clearStripes = () => {
    // Keep hero element but hide other stripes
    this.isStripesVisible = false;
  };

  resetStore = () => {
    this.isStripesVisible = true;
    this.heroElement = null;
  };

  handleSelectUniverse = (universeId: number) => {
    const stripesStore = this.rootStore.stripesProviderStore;

    // Update universe ID in provider store
    stripesStore.setSelectedUniverseId(universeId);
    if (stripesStore.params) {
      stripesStore.setParams({
        ...stripesStore.params,
        universeId
      });
    }

    // Save current hero and clear other stripes
    this.setHeroElement(stripesStore.heroUiElements);
    stripesStore.setUiElements([]);
    stripesStore.setHeroUiElements(this.heroElement);
    this.setStripesVisibility(false);

    // Fetch new genres for selected universe
    stripesStore.fetchGenres().then((applied) => {
      // A stale/superseded fetch must not reveal stripes while a newer selection is still
      // loading - that would uncover an empty stripe area under the (soon to be overwritten) old state.
      if (applied) this.setStripesVisibility(true);
    });
  };
}

export default UIStoreProvider;
